import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import agent from "../agent/agent";

const initialState = {
  contract: null,
  contracts: [],
  isLoading: false,
  error: null,
};

export const fetchContracts = createAsyncThunk(
  'ContractsStore/fetchContracts',
  async () => {
    return await agent.get('/statistics').then((res) => res.data?.data || []).catch(() => []);
  }
);
export const refreshContracts = createAsyncThunk(
  'ContractsStore/refreshContracts',
  async (_, { getState }) => {
    const contracts = await agent.get('/statistics').then((res) => res.data?.data || []).catch(() => []);

    const storedId = localStorage.getItem('activeContractId');
    const currentContract = getState()?.contracts?.contract;
    const currentId = currentContract?.available_contracts?.contract_id;
    const targetId = storedId || currentId || null;

    let nextContract = null;
    if (Array.isArray(contracts) && contracts.length > 0) {
      if (targetId) {
        const matched = contracts.find((item) => item?.available_contracts?.contract_id === targetId);
        nextContract = matched || contracts[0];
      } else {
        nextContract = contracts[0];
      }
    }

    const nextId = nextContract?.available_contracts?.contract_id;
    if (nextId) {
      localStorage.setItem('activeContractId', nextId);
    } else {
      localStorage.removeItem('activeContractId');
    }

    return { contracts, contract: nextContract };
  }
);

export const ContractsStore = createSlice({
  name: 'ContractsStore',
  initialState,
  reducers: {
    setContract: (state, action) => {
      const next = action.payload || null;
      state.contract = next;
      const id = next?.available_contracts?.contract_id;
      if (id) {
        localStorage.setItem('activeContractId', id);
      } else {
        localStorage.removeItem('activeContractId');
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContracts.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchContracts.fulfilled, (state, action) => {
      state.isLoading = false;
      state.contracts = action.payload || [];
      if (!state.contract && Array.isArray(state.contracts) && state.contracts.length > 0) {
        const storedId = localStorage.getItem('activeContractId');
        const matched = storedId
          ? state.contracts.find((item) => item?.available_contracts?.contract_id === storedId)
          : null;
        state.contract = matched || state.contracts[0] || null;

        const id = state.contract?.available_contracts?.contract_id;
        if (id) {
          localStorage.setItem('activeContractId', id);
        } else {
          localStorage.removeItem('activeContractId');
        }
      }
    });
    builder.addCase(fetchContracts.rejected, (state) => {
      state.isLoading = false;
      state.error = 'Ошибка при загрузке контрактов';
      state.contracts = [];
    });

    builder.addCase(refreshContracts.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(refreshContracts.fulfilled, (state, action) => {
      state.isLoading = false;
      state.contracts = action.payload?.contracts || [];
      state.contract = action.payload?.contract || null;
    });
    builder.addCase(refreshContracts.rejected, (state) => {
      state.isLoading = false;
      state.error = 'Ошибка при обновлении контрактов';
      state.contracts = [];
      state.contract = null;
    });
  }
});
export const { setContract } = ContractsStore.actions;
export default ContractsStore.reducer;
